import {connect} from 'react-redux';
import CopyrightPolicy from './CopyrightPolicy';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';

export default connect(null, {setNavigationAnnouncement})(CopyrightPolicy);
